import React from 'react'
import Accordion from 'react-bootstrap/Accordion'

function IndustriesFaq() {
    const faqs = [
        {
            q: 'Does TechDigit Solutions only work with healthcare companies?',
            a: "No. While healthcare is TechDigit's founding specialty, the company serves clients across all industries, including financial services, technology, legal, publishing, education, manufacturing, retail and more, with a particular focus on cybersecurity and professional content writing services.",
        },
        {
            q: 'Does TechDigit Solutions write fiction and non-fiction books?',
            a: "Yes. TechDigit's content team ghostwrites and produces professional long-form content across fiction, non-fiction, self-help, business, memoirs, and educational material for authors, coaches, consultants, and publishers.",
        },
        {
            q: "Which industries does TechDigit's cybersecurity service cover?",
            a: "All industries. Cyber threats are not sector-specific and neither is TechDigit's security practice. The company designs security programs for healthcare, finance, technology, legal, manufacturing, retail, and other businesses that need enterprise-grade protection.",
        },
        {
            q: "Can TechDigit Solutions work with my industry even if it's not listed?",
            a: 'Yes. TechDigit works with any industry that needs operational excellence, cybersecurity protection, or professional content. The first consultation is free and there is no obligation.',
        },
    ]
    return (
        <div className="faq-techdigit industries-faq td-section td-section--faq rts-faq-section rts-section-gap">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-xl-9">
                        <div className="faq-techdigit-inner">
                            <div className="td-section-head text-center mb-5">
                                <p className="td-section-label">Industries</p>
                                <h2 className="td-section-title">Questions About Who TechDigit Solutions Works With</h2>
                                <div className="td-title-rule td-title-rule--center mx-auto" aria-hidden="true" />
                            </div>
                            <div className="faq-accordion-area">
                                <Accordion defaultActiveKey="0">
                                    {faqs.map((faq, i) => (
                                        <Accordion.Item key={i} eventKey={String(i)}>
                                            <Accordion.Header>{faq.q}</Accordion.Header>
                                            <Accordion.Body>{faq.a}</Accordion.Body>
                                        </Accordion.Item>
                                    ))}
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default IndustriesFaq
